function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import ContainerComponent from './container';
import SubscriberComponent from './subscriber';

var noop = function noop() {
  return function () {};
};

var defaultSelector = function defaultSelector(state) {
  return state;
};

export function createSubscriber(Store) {
  var _class, _temp;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$selector = _ref.selector,
      selector = _ref$selector === void 0 ? defaultSelector : _ref$selector,
      _ref$displayName = _ref.displayName,
      displayName = _ref$displayName === void 0 ? '' : _ref$displayName;

  return _temp = _class = /*#__PURE__*/function (_SubscriberComponent) {
    _inherits(_class, _SubscriberComponent);

    function _class() {
      _classCallCheck(this, _class);

      return _possibleConstructorReturn(this, _getPrototypeOf(_class).apply(this, arguments));
    }

    return _class;
  }(SubscriberComponent), _defineProperty(_class, "storeType", Store), _defineProperty(_class, "displayName", displayName || "Subscriber(".concat(Store.key[0], ")")), _defineProperty(_class, "selector", selector), _temp;
}
export function createContainer(Store) {
  var _class2, _temp2;

  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref2$onInit = _ref2.onInit,
      onInit = _ref2$onInit === void 0 ? noop : _ref2$onInit,
      _ref2$onUpdate = _ref2.onUpdate,
      onUpdate = _ref2$onUpdate === void 0 ? noop : _ref2$onUpdate,
      _ref2$displayName = _ref2.displayName,
      displayName = _ref2$displayName === void 0 ? '' : _ref2$displayName;

  return _temp2 = _class2 = /*#__PURE__*/function (_ContainerComponent) {
    _inherits(_class2, _ContainerComponent);

    function _class2() {
      _classCallCheck(this, _class2);

      return _possibleConstructorReturn(this, _getPrototypeOf(_class2).apply(this, arguments));
    }

    return _class2;
  }(ContainerComponent), _defineProperty(_class2, "storeType", Store), _defineProperty(_class2, "displayName", displayName || "Container(".concat(Store.key[0], ")")), _defineProperty(_class2, "hooks", {
    onInit: onInit,
    onUpdate: onUpdate
  }), _temp2;
}